import { type ColumnFiltersState } from "@tanstack/react-table";

interface LockableColumn {
  getIsVisible: () => boolean;
}

export interface DatatableLock {
  readonly canOfferColumn: (column: LockableColumn) => boolean;
  readonly canShowFilterChip: (columnId: string) => boolean;
  readonly canToggleColumnVisibility: boolean;
  readonly publishedColumnFilterList: ColumnFiltersState;
}

export const createDatatableLock = ({
  isLocked,
  mountedColumnFilterList,
}: {
  isLocked: boolean;
  mountedColumnFilterList: ColumnFiltersState;
}): DatatableLock => {
  const mountedColumnIdSet = new Set(mountedColumnFilterList.map((columnFilter) => columnFilter.id));

  return {
    canOfferColumn: (column) => !isLocked || column.getIsVisible(),
    canShowFilterChip: (columnId) => !isLocked || !mountedColumnIdSet.has(columnId),
    canToggleColumnVisibility: !isLocked,
    publishedColumnFilterList: isLocked ? [...mountedColumnFilterList] : [],
  };
};
